const endpoints = {
  getPartnerContent: 'api/v2/partners_content/',
}

export default endpoints
